// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tower-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10 4L12 2L14 4L15 19H9L10 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M8 22V19H16V22H8Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10 4L12 2L14 4L15 19H9L10 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M8 22V19H16V22H8Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Tower2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tower-2',
    ref,
    icon: element,
  },
));

Tower2Icon.displayName = 'Tower2Icon';

export default Tower2Icon;
